import { useEffect } from 'react';
import axios from 'axios';
import { API_BASE } from '@/utils/api';

export const deviceId = () => {
  let id = localStorage.getItem('device_id');
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/-/g, '').slice(0, 32);
    localStorage.setItem('device_id', id);
  }
  return id;
};

// Latido del celular con la mesa abierta: el POS, el mozo y la caja ven cuántos hay conectados
export const useSessionPresence = (sessionId) => {
  useEffect(() => {
    if (!sessionId) return undefined;
    const url = `${API_BASE}/public/sessions/${sessionId}/presence`;
    const beat = (leaving = false) => axios.post(url, { device_id: deviceId(), leaving }).catch(() => {});
    const leave = () => {
      const tok = localStorage.getItem(`stoken_${sessionId}`);
      fetch(url, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'X-Session-Token': tok || '' },
        body: JSON.stringify({ device_id: deviceId(), leaving: true }) }).catch(() => {});
    };
    const onVisibility = () => (document.visibilityState === 'hidden' ? leave() : beat());
    beat();
    const id = setInterval(() => { if (document.visibilityState === 'visible') beat(); }, 20000);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('pagehide', leave);
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('pagehide', leave);
      leave();
    };
  }, [sessionId]);
};
